(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__belloreDrawerCrossSellReady) return;
    window.__belloreDrawerCrossSellReady = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-bc-drawer-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json',Accept:'application/json'},
          body: JSON.stringify({items:[{id:button.dataset.bcDrawerAdd,quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Ürün sepete eklenemedi.');
        button.classList.add('is-added');
        button.querySelector('span').textContent = 'Eklendi';

        const currentCartIcon = document.querySelector('cart-icon');
        const headerSectionId = currentCartIcon?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        const ids = ['cart-drawer-section',headerSectionId].filter(Boolean);
        const sections = await fetch('/?sections=' + ids.join(',')).then((res) => res.json());
        const holder = document.createElement('div');
        holder.innerHTML = sections['cart-drawer-section'] || '';
        const incoming = holder.querySelector('cart-items-component');
        const current = document.querySelector('cart-items-component');
        if (incoming && current) current.replaceWith(incoming);
        if (headerSectionId && sections[headerSectionId]) {
          const header = document.createElement('div');
          header.innerHTML = sections[headerSectionId];
          const icon = header.querySelector('cart-icon');
          if (icon && currentCartIcon) currentCartIcon.replaceWith(icon);
        }
      } catch (error) {
        button.disabled = false;
        window.alert(error.message);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
